OCMS.QAS = OCMS.QAS || {};
OCMS.QAS.isEditMode = OCMS.QAS.isEditMode || false;

function ResetQASZipFinder() {
  const formId = OCMS.QAS.formId;
  const formToReset = OCMS.QAS.ZipFinders.get(formId);
  if (typeof formToReset !== 'undefined') {
    formToReset.form.zipContainer.hide();
    const finderContainerId = `#finderContainer${formId}`;
    $(finderContainerId).show();
    formToReset.reset();
  }
}

function removeCommasOnBlur(value) {
  const val = value;
  return val.replace(',', '');
}

function removeNaNChar(value) {
  if (isNaN(value)) {
    return value.replace(/\D/g, '');
  }
  return value;
}

function QASZipFinder(options) {
  const that = this;

  let $finderContainer = null;
  let $finderField = null;
  let $finderLabel = null;
  let $finderButton = null;
  let $resetButton = null;
  let $finderButtonContainer = null;
  let $resetButtonContainer = null;
  let $finderLoader = null;
  let $finderResults = null;
  let $finderResultsContainer = null;
  let $skipButton = null;

  this.settings = options;
  this.form = null;

  this.searching = false;
  this.search = () => {
    if (that.searching === true) {
      return;
    }

    const query = $finderField.val();
    if ((query === undefined) || (query === null) || (query === '')) {
      return;
    }

    that.searching = true;
    $finderButtonContainer.hide();
    $finderField.hide();
    $finderLoader.show();
    $.ajax({
      url: '/ajax/ecombag_ajax.aspx',
      data: {
        task: 'qassearchaddress',
        search: $finderField.val()
      },
      dataType: 'json',
      type: 'POST',
      success(result) {
        window.searchedZip = $finderField.val();
        if ((result !== undefined) && (result.success === true)) {
          if (result.data.length > 0) {
            $finderResults.empty();
            $finderResults.append($('<option></option>').attr('value', '').text(that.settings.resources.resultLabel));
            // $finderLabel.text(that.settings.resources.resultLabel);
            for (let i = 0; i < result.data.length; i += 1) {
              if (result.data[i].value !== '') {
                $finderResults.append($('<option></option>').attr('value', result.data[i].value).text(result.data[i].text));
              }
            }
            if (typeof OCMS.QAS.autoSelect !== 'undefined' && OCMS.QAS.autoSelect === true) {
              if (result.data.length === 1) {
                $finderResults.val(result.data[0].value);
                $finderResults.change();
              }
            }
            $finderLoader.hide();
            $finderResultsContainer.show();
            $resetButtonContainer.show();
            that.searching = false;
          } else {
            that.skip();
          }
        } else {
          that.skip();
        }
      }
    });
  };

  this.reset = () => {
    $resetButtonContainer.hide();
    $finderButtonContainer.show();
    $finderResultsContainer.hide();
    $finderField.show();
    $finderLabel.text(that.settings.resources.finderLabel);
  };

  this.select = () => {
    const value = $finderResults.val();
    if ((value === undefined) || (value === null) || (value === '')) {
      return;
    }

    $.ajax({
      url: '/ajax/ecombag_ajax.aspx',
      data: {
        task: 'qasgetaddress',
        moniker: value
      },
      type: 'POST',
      success(data) {
        if (data !== undefined && data !== '') {
          that.settings.onSelect.call(that, that.form, $.parseJSON(data));

          that.skip();

          // Force form validation
          GetDefaultValidationResultWithoutHidden($('.ultimate-form-wrapper'));
        }
      }
    });
  };

  this.skip = () => {
    if (that.form.addressField.attr('data-hidden') !== 'true') { that.form.addressContainer.show(); }
    if (that.form.address2Field.attr('data-hidden') !== 'true') { that.form.address2Container.show(); }
    if (that.form.address3Field.attr('data-hidden') !== 'true') { that.form.address3Container.show(); }
    if (that.form.address4Field.attr('data-hidden') !== 'true') { that.form.address4Container.show(); }
    if (that.form.address5Field.attr('data-hidden') !== 'true') { that.form.address5Container.show(); }
    if (that.form.address6Field.attr('data-hidden') !== 'true') { that.form.address6Container.show(); }
    if (that.form.address7Field.attr('data-hidden') !== 'true') { that.form.address7Container.show(); }
    if (that.form.address8Field.attr('data-hidden') !== 'true') { that.form.address8Container.show(); }
    if (that.form.address9Field.attr('data-hidden') !== 'true') { that.form.address9Container.show(); }
    if (that.form.zipField.attr('data-hidden') !== 'true') { that.form.zipContainer.show(); }
    if (that.form.cityField.attr('data-hidden') !== 'true') { that.form.cityContainer.show(); }
    if (that.form.stateField.attr('data-hidden') !== 'true') { that.form.stateContainer.show(); }
    if (that.form.countryField.attr('data-hidden') !== 'true') { that.form.countryContainer.show(); }
    that.form.streetNumberContainer.show();

    const retryButton = document.createElement('a');
    retryButton.classList.add('a-btn');
    retryButton.id = 'qasRetryBtn';
    retryButton.text = $resetButton.text();

    if (that.form.zipContainer.find('#qasRetryBtn').length === 0) {
      that.form.zipContainer.append(retryButton);
    }
    $finderContainer.hide();
    ResetQASZipFinder();
  };

  this.tpl = (template, data) => {
    if (template.replace) {
      return template.replace(/\[\s*data\.(.+?)\s*]/g, (match, d) => {
        try {
          return data[d];
        } catch (e) {
          return ['{?', d, '}'].join('');
        }
      });
    }
    return '';
  };

  this.init = () => {
    this.form = OCMS.UltimateForms.get(this.settings.formId);
    if ((this.form === undefined) || (this.form === null)) {
      return;
    }
    OCMS.QAS.formId = this.settings.formId;
    if (OCMS.QAS.isEditMode === false) {
      this.form.streetNumberContainer.hide();
      this.form.addressContainer.hide();
      this.form.address2Container.hide();
      this.form.address3Container.hide();
      this.form.address4Container.hide();
      this.form.address5Container.hide();
      this.form.address6Container.hide();
      this.form.address7Container.hide();
      this.form.address8Container.hide();
      this.form.address9Container.hide();
      this.form.zipContainer.hide();
      this.form.cityContainer.hide();
      this.form.stateContainer.hide();
      this.form.countryContainer.hide();
    } else {
      this.form.zipContainer.hide();
      if (OCMS.QAS.StreetNumberActivated === true) {
        const currentAddress = this.form.address();
        if (typeof currentAddress !== 'undefined') {
          const streetNumberRegex = /\d+/;
          if (currentAddress.indexOf(',') > 0) {
            let lastCommaPosition = currentAddress.lastIndexOf(',');
            let numberStr = currentAddress.slice(lastCommaPosition + 1);
            numberStr = numberStr.trim();
            if (numberStr.match(streetNumberRegex) == null) {
              numberStr = '';
              lastCommaPosition = currentAddress.length;
            }
            const finalAdress = currentAddress.substring(0, lastCommaPosition);
            this.form.address(finalAdress);
            this.form.streetNumber(numberStr);
          }
        }
      }
    }

    this.form.addressField.change(() => {
      const addressValue = this.form.address();
      if (addressValue.indexOf(',') > 0) {
        this.form.address(removeCommasOnBlur(this.form.address()));
      }
    });

    this.form.streetNumberField.change(() => {
      const numberValue = this.form.streetNumber();
      if (numberValue.indexOf(',') > 0 || isNaN(numberValue)) {
        let finalValue = removeCommasOnBlur(this.form.streetNumber());
        finalValue = removeNaNChar(finalValue);
        this.form.streetNumber(finalValue);
      }
    });

    const data = $.extend({}, this.settings.resources, {
      id: this.settings.formId,
      brand: OCMS.GlobalVars.Brand,
      placeholder: this.form.zipField.attr('placeholder')
    });
    this.form.zipContainer.before($(this.tpl(this.settings.template, data)));

    $finderContainer = $(['#finderContainer', this.settings.formId].join(''));
    $finderField = $(['#finderField', this.settings.formId].join(''));
    $finderLabel = $(['#finderLabel', this.settings.formId].join(''));
    $finderButtonContainer = $(['#finderButton', this.settings.formId].join(''));
    $finderButton = $finderButtonContainer.find('a');
    $resetButtonContainer = $(['#resetButton', this.settings.formId].join(''));
    $resetButton = $resetButtonContainer.find('a');
    $finderLoader = $(['#finderLoader', this.settings.formId].join(''));
    $finderResultsContainer = $(['#finderResults', this.settings.formId].join(''));
    $finderResults = $finderResultsContainer.find('select');
    window.$skipContainer = $(['#skipContainer', this.settings.formId].join(''));
    $skipButton = $(['#skipButton', this.settings.formId].join(''));


    if (OCMS.QAS.isEditMode === true) {
      $finderField.val(this.form.zip());
    }

    $finderButton.click(this.search);
    $resetButton.click(this.reset);
    $finderResults.change(this.select);
    $skipButton.click(this.skip);
    if (typeof (this.settings.onInit) === 'function') {
      this.settings.onInit.call($finderField);
    }
  };

  this.init();
}

QASZipFinder.Defaults = {
  formId: 'checkout',
  template:
    `<div id="finderContainer[data.id]" class="o-ultimateform__field">
    <div class="ultiFormRow ultiFormQas  m-private-input">
    <label class="ultiFormlabel m-private-input__title a-label a-label--italic" id="finderLabel[data.id]">
    [data.finderLabel]
    </label>
    <div class="ultiFormInput">
    <input type="text" id="finderField[data.id]" placeholder="[data.placeholder]" class="m-private-input__input mobileValidation digits" value="[data.value]"/>
    <div class="select-wrapper" id="finderResults[data.id]" style="display: none;">
    <div class="icon"></div>
    <select style="width: 100%;"></select>
    </div>
    </div>
    </div>
    <div>
    <div><img id="finderLoader[data.id]" style="display: none; margin: auto auto;" src="/img/[data.brand]/new/wait.gif" /></div>
    <div id="finderButton[data.id]"><a href="javascript:void(0);" class="a-btn">[data.finderButton]</a></div>
    <div id="resetButton[data.id]" class="a-btn--padded" style="display:none;"><a href="javascript:void(0);" class="button_secondary button_qas a-btn--left">[data.resetButton]</a></div>
    <div class="skipQas" id="skipContainer[data.id]">
    </div>
    </div>
  </div>`,
  resources: {
    finderLabel: 'Enter postcode',
    finderButton: 'ADDRESS FINDER',
    resultLabel: 'Choose your address',
    resetButton: 'Reset',
    skipLabel: 'Ordering outside of the UK ?',
    skipButton: 'Click here to enter your international address',
    value: ''
  }
};


function QASZipFinders() {
  const forms = {};

  this.register = (options) => {
    const option = $.extend(true, QASZipFinder.Defaults, options);
    forms[option.formId] = new QASZipFinder(option);
  };

  this.get = form => forms[form];
}

OCMS.QAS.ZipFinders = new QASZipFinders();

$(document).on('click', '#qasRetryBtn', ResetQASZipFinder);



// WEBPACK FOOTER //
// ./js/plugins/qas.zip-finder.js